import type { RecoilTaskInterface } from 'recoil-toolkit';

import { userService } from '../../../api';
import { currentEventIdState } from '../../../state/event';
import { usersState } from './atoms';

export const getUsersTask =
  ({ set, snapshot }: RecoilTaskInterface) =>
  async () => {
    const eventId = snapshot.getLoadable(currentEventIdState).getValue();
    if (eventId) {
      const users = await userService.getUsers({ eventId });
      const uniqueUsers = Array.from(new Map(users.map((user) => [user.id, user])).values());
      set(usersState, uniqueUsers);
    }
  };
